import React from 'react';
import { render } from 'react-dom';
import App from './App';
import ConfirmPromptState from './state/ConfirmPrompt';
import { ConfirmPromptModal } from 'ui/components';

/**
 * Load application styles
 */
import 'ui/assets/styles/app.scss';

/*
 * Reusable render of the app to be used for hmr
 */
const bootstrap = Component =>
	render(<Component />, document.getElementById('application'));

/**
 * In development request a dnumber to login
 * this is removed at build time for production
 */
/* istanbul ignore if  */
import { IS_USING_OLD_SSO } from 'config/constants';

if (__DEV__ && IS_USING_OLD_SSO) {
	const Cookie = require('js-cookie');

	if (!Cookie.get('loginId')) {
		const dnumber = window.prompt('Enter a D Number', 'd10393');
		Cookie.set('loginId', dnumber);
	}
}

import { authorize as authorizeSSO } from 'sso-auth/authenticate';

if (!IS_USING_OLD_SSO) {
	authorizeSSO();
}

/** Google Tag Manager */
import TagManager from 'react-gtm-module';
import env from 'config/env';

if (env.googleTagManagerContainerId) {
	TagManager.initialize({ gtmId: env.googleTagManagerContainerId });
}

/**
 * Accept hmr updates and re-render the app
 */
if (__DEV__) {
	module.hot.accept('./App', () => bootstrap(App));
}

/**
 * Render the application
 */
bootstrap(App);

render(
	<ConfirmPromptModal ConfirmPromptState={ConfirmPromptState} />,
	document.getElementById('confirmationModals')
);



// WEBPACK FOOTER //
// ./src/index.js